import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=be566846"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be566846')) {
      api.createRecord('be566846', component.options)
    } else {
      api.reload('be566846', component.options)
    }
    module.hot.accept("./AlertIcon.vue?vue&type=template&id=be566846", function () {
      api.rerender('be566846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/status/AlertIcon.vue"
export default component.exports